import { Injectable } from '@angular/core';
import { environment } from "@environments/environment";
import { HttpClient } from "@angular/common/http";
import {ExpectedActionsResponse} from "../models/expected-actions-response";

@Injectable({
  providedIn: 'root'
})
export class ExpectedActionsService {
  private url: string = environment.apiUrl + '/expectedAction';
  private _expectedActions$ = this.httpClient.get<ExpectedActionsResponse>(this.url);
    //.pipe(shareReplay({ bufferSize: 1, refCount: true }));

  get expectedActions$() { return this._expectedActions$; }

  constructor(private httpClient: HttpClient) { }
}
